import { computed } from 'vue'
import i18n from '@/app/plugins/i18n'
import { useAppStore } from '@/app/store/app.store.ts'
import type { AppLocale } from '@/types'
import { APP_LOCALES } from '@/constants/app.constant'


export function useLocale() {
  const appStore = useAppStore()

  const currentLocale = computed(() => (i18n.global as any).locale.value)

  const languages = [
    { code: 'vi', label: 'Tiếng Việt' },
    { code: 'en', label: 'English' },
  ]

  const setLocale = (code: AppLocale) => {
    ; (i18n.global as any).locale.value = code
    appStore.setLocale(code)
    document.documentElement.lang = code
  }

  const toggleLocale = () => {
    const nextCode = currentLocale.value === APP_LOCALES.VI ? APP_LOCALES.EN : APP_LOCALES.VI
    setLocale(nextCode)
  }

  const currentLanguage = computed(() =>
    languages.find(lang => lang.code === currentLocale.value) || languages[0]
  )

  return {
    currentLocale,
    languages,
    currentLanguage,
    setLocale,
    toggleLocale
  }
}
